/* @flow */
import React from 'react';
import { browserHistory } from 'react-router';

const stack = [];

function handleTransition() {
  let l = stack.length;
  while (l--) {
    const layer = stack[l];
    if (layer && layer.props.hideOnTransition) {
      if (layer.props.onRequestHide) {
        layer.props.onRequestHide();
      }
    }
  }
}

if (browserHistory) {
  browserHistory.listen(handleTransition);
}

const LayerHideOnTransition = {
  propTypes: {
    hideOnTransition: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      hideOnTransition: true,
    };
  },

  componentDidMount() {
    stack.push(this);
  },

  componentWillUnmount() {
    const index = stack.indexOf(this);
    if (index >= 0) {
      stack.splice(index, 1);
    }
  },
};

export default LayerHideOnTransition;



// WEBPACK FOOTER //
// ./src/components/mixins/LayerHideOnTransition.js